import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextM, TextS } from 'frontend/js/modules/infra/dls/components/typography';
import styles from '../styles.module.scss';
import { formatNumber } from '../../../../../../../app/common/money';
export var AudienceColumn = function (_a) {
    var audienceNames = _a.audienceNames, totalCount = _a.totalCount;
    return (_jsxs("div", { className: styles.multiline, children: [_jsx(TextM, { color: "primary", className: styles.header, children: audienceNames.join(', ') }), _jsx(TextS, { color: "secondary", children: totalCount > 0 ? "".concat(formatNumber(totalCount, 0), " recipients") : '' })] }));
};
